import React from 'react';
import { FileText, WadOfMoney, Smartphone, Letter } from '@solar-icons/react';
import { useTranslation } from 'react-i18next';

const LegacyVaultProductShowcase: React.FC = () => {
    const { t } = useTranslation();
    const layers = [
        {
            icon: <FileText size={24} color="#2a6355" className='dark:text-primary-light' />,
            title: t('lv_page.showcase.legal_layer'),
            features: [t('lv_page.showcase.will_trust_templates'), t('lv_page.showcase.property_deeds_tracker')],
        },
        {
            icon: <WadOfMoney size={24} color="#2a6355" className='dark:text-primary-light' />,
            title: t('lv_page.showcase.financial_layer'),
            features: [t('lv_page.showcase.auto_updating_net'), t('lv_page.showcase.hidden_account_locator')],
        },
        {
            icon: <Smartphone size={24} color="#2a6355" className='dark:text-primary-light' />,
            title: t('lv_page.showcase.digital_layer'),
            features: [t('lv_page.showcase.password_transition_system'), t('lv_page.showcase.social_media_memorial_planner')],
        },
        {
            icon: <Letter size={24} color="#f38173" className='dark:text-secondary' />,
            title: t('lv_page.showcase.heart_layer'),
            features: [t('lv_page.showcase.open_when'), t('lv_page.showcase.legacy_interview_prompts')],
        },
    ];

    return (
        <section className="overflow-x-hidden py-12 lg:py-16">
            <div className="relative mx-auto max-w-[1142px] px-4">
                <div className="mx-auto pb-14 text-center lg:w-2/3 lg:pb-24">
                    <h2 className="mb-5 text-[26px]/7 font-bold text-green-700 dark:text-white">{t('lv_page.showcase.title')}</h2>
                    <p className="text-lg md:text-xl">{t('lv_page.showcase.subtitle')}</p>
                </div>

                <div className="grid gap-8 lg:grid-cols-2">
                    <div className="space-y-8">
                        {layers.slice(0, 2).map((layer, index) => (
                            <div
                                key={index}
                                className="group relative rounded-xl border border-green-200 bg-white p-8 transition-all duration-300 hover:border-green-300 hover:shadow-lg dark:border-green-800 dark:bg-dark dark:hover:border-green-700"
                                data-aos="fade-right"
                                data-aos-duration="1000"
                                data-aos-delay={index * 200}
                            >
                                <div className="mb-4 flex items-center gap-4">
                                    {layer.icon}
                                    <h3 className="text-xl font-bold text-green-700 dark:text-white">{layer.title}</h3>
                                </div>
                                <ul className="space-y-2">
                                    {layer.features.map((feature, featureIndex) => (
                                        <li key={featureIndex} className="flex items-center gap-2 text-gray-600 dark:text-gray-300">
                                            <span className="h-2 w-2 rounded-full bg-green-500"></span>
                                            {feature}
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        ))}
                    </div>

                    <div className="space-y-8">
                        {layers.slice(2, 4).map((layer, index) => (
                            <div
                                key={index + 2}
                                className="group relative rounded-xl border border-green-200 bg-white p-8 transition-all duration-300 hover:border-green-300 hover:shadow-lg dark:border-green-800 dark:bg-dark dark:hover:border-green-700"
                                data-aos="fade-left"
                                data-aos-duration="1000"
                                data-aos-delay={(index + 2) * 200}
                            >
                                <div className="mb-4 flex items-center gap-4">
                                    {layer.icon}
                                    <h3 className="text-xl font-bold text-green-700 dark:text-white">{layer.title}</h3>
                                </div>
                                <ul className="space-y-2">
                                    {layer.features.map((feature, featureIndex) => (
                                        <li key={featureIndex} className="flex items-center gap-2 text-gray-600 dark:text-gray-300">
                                            <span className="h-2 w-2 rounded-full bg-green-500"></span>
                                            {feature}
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        ))}
                    </div>
                </div>

                {/* <div className="mt-12 text-center">
                    <button className="inline-flex py-[15px] px-6 bg-primary text-white rounded-lg font-semibold hover:bg-primary-dark transition-colors" onClick={handleExploreClick}>
                        Explore Full Contents →
                    </button>
                </div> */}
            </div>
        </section>
    );
};

export default LegacyVaultProductShowcase;
